'use strict';
require('./global');

